import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SelectField from 'components/input/SelectField/SelectField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import currencyHelper from 'helpers/currencyHelper';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm } from 'redux-form';
import RenderProductInputField from 'components/form/InputFields/AutoCompleteField/RenderProductInputField';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';
import RenderAutoCompleteDataInputField from 'components/form/InputFields/AutoCompleteField/RenderAutoCompleteDataInputField';
import { toNumber } from 'lodash';

const ProductMembershipForm = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        submitting,
        translate,
    } = props;

    const normalizePrice = (value) => {
        return toNumber(value) || 0;
    };

    return (
        <FormWrapper>
            <form onSubmit={ handleSubmit(handleSubmitForm) }>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderProductInputField }
                                fullWidth={ true }
                                name='product_id'
                                label={ translate('resources.subscriptionProducts.fields.product') }
                                validate={ validations.required }
                            />
                        </Item>
                    </Row>
                </Section>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderAutoCompleteDataInputField }
                                fullWidth={ true }
                                name='membership_schedule_id'
                                label={ translate('resources.product_memberships.fields.membership_schedule') }
                                optionValue='id'
                                reference='membership-schedules'
                                searchBy='name'
                                searchParams={ {
                                    size: 12,
                                    sort_by: 'name',
                                    sort_direction: 'asc',
                                } }
                            />
                        </Item>
                    </Row>
                </Section>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ false }
                                label={ translate('filters.components.name.label') }
                                name='name'
                                validate={ validations.required }
                            />
                        </Item>
                    </Row>
                </Section>

                <Section title={ translate('resources.users.memberships.pricing') }>
                    <Row>
                        <Item>
                            <Field
                                choices={ currencyHelper.currencyChoices }
                                component={ SelectField }
                                floatingLabelFixed={ true }
                                label={ translate('fields.currency') }
                                optionText='name'
                                optionValue='code'
                                name='currency'
                                validate={ [
                                    validations.required,
                                ] }
                            />
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <Item>
                                <Field
                                    component={ RenderBooleanInputField }
                                    label={ translate('resources.product_memberships.fields.supports_ondemand') }
                                    name='supports_ondemand'
                                />
                            </Item>
                        </Item>

                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                floatingLabelFixed={ true }
                                fullWidth={ true }
                                label={ translate('resources.product_memberships.fields.price_ondemand') }
                                name='price_ondemand'
                                normalize={ normalizePrice }
                                type='number'
                            />
                        </Item>
                    </Row>
                    <Row>
                        <Item>
                            <Item>
                                <Field
                                    component={ RenderBooleanInputField }
                                    label={ translate('resources.product_memberships.fields.supports_scheduled') }
                                    name='supports_scheduled'
                                />
                            </Item>
                        </Item>

                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                floatingLabelFixed={ true }
                                fullWidth={ true }
                                label={ translate('resources.product_memberships.fields.price_scheduled') }
                                name='price_scheduled'
                                normalize={ normalizePrice }
                                type='number'
                            />
                        </Item>
                    </Row>

                    <Row>
                        <Item>
                            <Field
                                component={ RenderBooleanInputField }
                                label={ translate('resources.products.fields.is_visible') }
                                name='is_visible'
                            />
                        </Item>
                    </Row>
                </Section>

                <Section>
                    <Row>
                        <ButtonWrapper>
                            <SubmitButton loading={ submitting } />
                        </ButtonWrapper>
                    </Row>
                </Section>
            </form>
        </FormWrapper>
    );
};

ProductMembershipForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.name) {
                errors.name = translate('forms.required');
            }

            if (!values.currency) {
                errors.currency = translate('forms.required');
            }

            if (!values.product_id) {
                errors.product_id = translate('forms.required');
            }

            if (!values.membership_schedule_id) {
                errors.membership_schedule_id = translate('forms.required');
            }

            if (values.supports_ondemand && values.price_ondemand === null) {
                errors.price_ondemand = translate('forms.required');
            }

            if (values.supports_scheduled && values.price_scheduled === null) {
                errors.price_scheduled = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(ProductMembershipForm);


// WEBPACK FOOTER //
// ./src/pages/product-memberships/create/ProductMembershipForm.js